export default __webpack_public_path__ + "static/media/pokemon_double_rare.4572677c.svg";